import React from 'react';
import { useAuth } from '../../context/AuthContext';

// Employee Expense vouchers: open to every authenticated employee
const ExpenseEmployeeRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <div>Loading...</div>;
  return children;
};

export default ExpenseEmployeeRoute;
